import { createSlice } from "@reduxjs/toolkit";

export const verifyEmailSlice = createSlice({
  name: 'verifyEmail',
  initialState: {
    data: null,
    error: null,
    isLoading: false
  },
  reducers: {
    startVerifyEmail: (state) => { state.isLoading = true; },
    setVerifyEmail: (state, { payload: { data = null, error = null }}) => {
      state.data = data;
      state.error = error;
      state.isLoading = false;
    }
  }
});

export const { startVerifyEmail, setVerifyEmail } = verifyEmailSlice.actions;
